
import Setting from '@/components/Settings/Setting'
import Button from '@/components/UntitledUI/Button.vue'

export default {
    name: 'TwoFactorAuth',
    components: { Button, Setting },
    data () {
        return {
            via: 'sms',
            sendCodeForm: new this.$vForm({
                via: this.via,
                phone: ''
            }),
            codeSent: false,
            verifyCodeForm: new this.$vForm({
                via: this.via,
                code: ''
            })
        }
    },
    computed: {
        isPhoneChanged () {
            return this.$auth.user.phone_verified_at === false || this.$auth.user.phone !== this.sendCodeForm.phone
        }
    },
    mounted () {
        this.reset()
    },
    methods: {
        send (via) {
            this.via = via
            this.sendCodeForm.via = this.via
            this.sendCodeForm.post('/v1/settings/SendSmsActivationCode')
                .then(() => {
                    this.codeSent = true
                })
                .catch((e) => {
                    if (e.response?.status !== 422 && e.response?.status !== 403) {
                        throw e
                    }
                    this.sendCodeForm.errors.set(e.response.data.errors)
                    if ('sms_2FA' in e.response.data.errors) {
                        this.$refs.settings.alert({
                            type: 'danger',
                            body: e.response.data.errors['sms_2FA'][0]
                        })
                    }
                })
        },
        verify () {
            this.verifyCodeForm.via = this.via
            this.verifyCodeForm.post('/v1/settings/VerifySmsActivationCode')
                .then((res) => {
                    this.$auth.setUser(res.data)
                    this.reset()
                    this.$refs.settings.alert({
                        type: 'success',
                        body: this.$t('settings security two factor phone number updated successfully')
                    })
                })
                .catch((e) => {
                    if (e.response?.status !== 422 && e.response?.status !== 403) {
                        throw e
                    }
                    this.verifyCodeForm.errors.set(e.response.data.errors)
                    if ('sms_2FA' in e.response.data.errors) {
                        this.verifyCodeForm.code = ''
                        this.codeSent = false
                        this.$refs.settings.alert({
                            type: 'danger',
                            body: e.response.data.errors['sms_2FA'][0]
                        })
                    }
                })
        },
        reset () {
            this.sendCodeForm.phone = this.$auth.user.phone
            this.codeSent = false
        }
    }

}
